export default "__VITE_ASSET__Bd8N8QQ6__"